import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../shared/services/auth.service";
import {AppointmentDto, CreateAppointmentDto, UpdateAppointmentDto} from "./dto/appointment.dto";

export async function getAppointments(navigate: NavigateFunction): Promise<AppointmentDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  const appointments = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/appointments`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch appointments: ${response.statusText}`);
      }
      return await response.json() as AppointmentDto[]
    });
  return appointments;
}

export async function getAppointment(navigate: NavigateFunction, appointmentId: number): Promise<AppointmentDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const appointment = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/appointments/${appointmentId}`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch appointment: ${response.statusText}`);
      }
      return await response.json() as AppointmentDto
    });
  return appointment;
}

export async function createAppointment(navigate: NavigateFunction, appointment: CreateAppointmentDto): Promise<AppointmentDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const createdAppointment = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/appointments`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(appointment)
    }).then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to create appointment: ${response.statusText}`);
      }
      return await response.json() as AppointmentDto
  });
  return createdAppointment;
}

export async function updateAppointment(navigate: NavigateFunction, appointmentId: number, appointment: UpdateAppointmentDto): Promise<AppointmentDto> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/appointments/${appointmentId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(appointment),
      headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
    })
    .then(async r => r.ok ? (await r.json()) as AppointmentDto : Promise.reject(r));
  return response;
}

export async function deleteAppointment(navigate: NavigateFunction, appointmentId: number): Promise<void> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/appointments/${appointmentId}`,
    {
      method: 'DELETE',
      headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
    });
  if(!response.ok) {
    throw new Error(`Failed to delete appointment: ${response.statusText}`);
  }
}